<template>
  <div class="content-section p-2 md:p-4">
    <div class="my-2 md:mx-8">
      <div class="min-h-screen p-2 md:p-4">
        <h1 class="text-3xl font-bold mb-4">Contact Us</h1>

        <span class="p-float-label">
          <label for="name">Your Name</label>
          <InputText id="name" v-model="name" class="w-full" />
        </span>

        <span class="p-float-label">
          <label for="email">Email</label>
          <InputText id="email" v-model="email" type="email" class="w-full" />
        </span>

        <span class="p-float-label">
          <label for="message">Message</label>
          <Textarea id="message" v-model="message" rows="10" class="w-full" />
        </span>

        <Button
          label="Send Message"
          icon="pi pi-send"
          class="p-button-primary p-button-rounded w-full mt-4"
          @click="sendMessage"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'
import InputText from 'primevue/inputtext'

const name = ref('')
const email = ref('')
const message = ref('')

const sendMessage = () => {
  alert('Message sent!')
}

onMounted(() => {
  window.scrollTo(0, 0)
})
</script>

<style scoped>
.content-section {
  min-height: 80vh;
  background:
    linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.8)),
    url('@/assets/images/set-whenever-bet/07-resized.jpeg');
  background-size: cover;
  background-position: center;
}
</style>
